import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CognitoService } from '../services/cognito.service';
import { InitService } from '../services/init.service';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.css'],
})
export class CallbackComponent implements OnInit {
  constructor(
    private readonly router: Router,
    private readonly cognitoService: CognitoService,
    private readonly serviceInit: InitService
  ) {}

  async ngOnInit() {
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));

      const authenticated = await this.cognitoService.isAuthenticated();
      if (!authenticated) {
        await this.router.navigate(['/auth'], {
          queryParams: { error: 'auth_failed' },
        });
        return;
      }

      const authorized = await this.cognitoService.isAuthorized();
      if (!authorized) {
        sessionStorage.setItem('auth_access_denied', '1');
        await this.cognitoService.signOut();
        return;
      }

      await this.cognitoService.hydrateUserContext();
      this.serviceInit.setEstadoLayout(true);
      const returnUrl = sessionStorage.getItem('auth_return_url') || '/home';
      sessionStorage.removeItem('auth_return_url');
      await this.router.navigateByUrl(returnUrl);
    } catch (error) {
      console.error('Error en el callback de autenticación:', error);
      await this.router.navigate(['/auth'], {
        queryParams: { error: 'callback_error' },
      });
    }
  }
}
